import script from "./AccountActivities.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountActivities.vue?vue&type=script&setup=true&lang=ts"

import "./AccountActivities.vue?vue&type=style&index=0&id=9bc64138&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bc64138"]])

export default __exports__